<!-- Value formatting lives in reporting-core/cell-format (formatCell), shared
     with the emailed-reports renderer. This template only adds presentation:
     the muted "None" placeholder and the no-wrap on dates. 'text' columns
     render the raw content as-is (and never show "None"). -->
<ng-container *ngIf="columnType === ReportCellType.text; else typed">{{ formattedValue }}</ng-container>
<ng-template #typed>
  <span *ngIf="formattedValue !== null" [class.text-nowrap]="columnType === ReportCellType.date">
    {{ formattedValue }}
  </span>
  <span *ngIf="formattedValue === null" class="text-muted">
    None
  </span>
</ng-template>
